import type { ReactNode } from 'react';
import { cn } from '../cn.js';

interface TrustBadgeProps {
  icon?: ReactNode;
  children: ReactNode;
  tone?: 'aurora' | 'jade';
  className?: string;
}

const toneClass: Record<NonNullable<TrustBadgeProps['tone']>, string> = {
  aurora: 'border-aurora/30 text-aurora',
  jade: 'border-jade/30 text-jade',
};

/**
 * Slim "we processed this locally" pill used above webcam/mic capture surfaces.
 * Designed to read calm — not alarmist — but visible enough to lower hesitation
 * at the moment of permission grant.
 */
export function TrustBadge({ icon, children, tone = 'aurora', className }: TrustBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-2 rounded-pill border px-3 py-1 font-mono text-xs uppercase tracking-[0.18em]',
        toneClass[tone],
        className,
      )}
      style={{
        background: 'color-mix(in oklab, currentColor 10%, var(--surface-1))',
      }}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      <span>{children}</span>
    </span>
  );
}
